import { useTranslation } from '@portals-platform/i18n';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@portals-platform/ui';
import type { StorageLocation } from '../../data-access/index.js';
import { formatMoney } from './certificate-format.js';

export function StorageLocationsTable({
  storageLocations,
}: {
  storageLocations: StorageLocation[];
}) {
  const { t } = useTranslation();

  return (
    <div className="max-h-64 overflow-y-auto rounded-[var(--radius-md)] border border-border">
      <Table>
        <TableHeader className="sticky top-0 bg-muted">
          <TableRow>
            <TableHead className="px-3">
              {t('certificates.details.fields.storageAddress')}
            </TableHead>
            <TableHead className="px-3 text-right">
              {t('certificates.details.fields.storageLimit')}
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {storageLocations.map((location) => (
            <TableRow key={`${location.storageLocation}|${location.currency}|${location.amount}`}>
              <TableCell className="max-w-0 w-full truncate px-3" title={location.storageLocation}>
                {location.storageLocation}
              </TableCell>
              <TableCell className="px-3 text-right tabular-nums">
                {formatMoney(location)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
